import { OrderHeaderURLs } from '../../../../baseComponents/TwinTable/InputTableLayout/types'

const useSellTicketHeaderUrls = () => {
    const orderHeaderURLs: OrderHeaderURLs = {
        createCost: '',
        updateCost: '',
        deleteCost: '',
        createFinancialRow: '/api/app/order/tpv/sellTicket/orderFinancialRow/createSellTicketFinancialRow',
        updateFinancialRow: '/api/app/order/tpv/sellTicket/orderFinancialRow/updateSellTicketFinancialRow',
        deleteFinancialRow: '/api/app/order/tpv/sellTicket/orderFinancialRow/deleteSellTicketFinancialRow',
        createAccount: '',
        updateAccount: '',
        deleteAccount: '',
        createShipping: '',
        updateShipping: '',
        createVariable: '',
        updateVariable: '',
        deleteVariable: '',
        updateWorkingCenter: '/api/app/order/tpv/sellTicket/updateSellTicketWorkingCenter',
        createUpdateProductTypes: ''
    }
    return orderHeaderURLs
}

export default useSellTicketHeaderUrls